import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';

@Component({
    // tslint:disable-next-line
    selector: 'body',
    template: '<router-outlet></router-outlet>'
})
export class AppComponent implements OnInit {
    constructor(
        private router: Router, 
        private activatedRoute: ActivatedRoute,
        private titleService: Title 
    ) {}

    ngOnInit() {

        // ホームページスタイル変更
        this.router.events
            .filter(event => event instanceof NavigationEnd)
            .subscribe((event: NavigationEnd) => {
                if (event.url != '/' && event.url != '/main') {
                    document.querySelector('body').classList.remove('show-home');
                    document.querySelector('body').classList.remove('sidebar-hidden');
                }
            });


        // ページタイトル変更
        this.router.events
            .filter(event => event instanceof NavigationEnd)
            .map(() => this.activatedRoute)
            .map((route) => {
                while (route.firstChild) route = route.firstChild;
                return route;
            })
            .filter((route) => route.outlet === 'primary')
            .mergeMap((route) => route.data)
            .subscribe((routeData) => {
                this.titleService.setTitle(routeData['title']);
                window.scrollTo(0, 0);
            });
        };

}



// WEBPACK FOOTER //
// E:/02_workspace/TenneT/git/tennet_suggestion_box/client/src/app/app.component.ts